import { useState } from "react";
import { signup } from "../services/api";

export default function Signup({ goToLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSignup = async () => {
    setMessage("");

    // ✅ Basic validation
    if (!email || !password) {
      setMessage("Email and password are required");
      return;
    }

    if (password !== confirmPassword) {
      setMessage("Passwords do not match");
      return;
    }

    try {
      setLoading(true);

      const res = await signup({ email, password });

      if (res.data.error) {
        setMessage(res.data.error);
      } else {
        setMessage("✅ Signup successful! Redirecting to login...");

        // 🔁 Auto redirect after 1.5 sec
        setTimeout(() => {
          goToLogin();
        }, 1500);
      }

    } catch (err) {
      setMessage("Signup failed. Please try again.");
    }

    setLoading(false);
  };

  return (
    <div className="flex flex-col items-center mt-20">

      <h1 className="text-2xl mb-4">Signup</h1>

      <input
        className="border p-2 mb-2 w-64"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />

      <input
        className="border p-2 mb-2 w-64"
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />

      <input
        className="border p-2 mb-2 w-64"
        type="password"
        placeholder="Confirm Password"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
      />

      <button
        onClick={handleSignup}
        disabled={loading}
        className="bg-green-600 text-white px-4 py-2 mt-2 w-64"
      >
        {loading ? "Signing up..." : "Signup"}
      </button>

      {message && (
        <p className="mt-3 text-center text-sm text-gray-700">
          {message}
        </p>
      )}

      <p className="mt-4">
        Already have an account?{" "}
        <span
          onClick={goToLogin}
          className="text-blue-600 cursor-pointer"
        >
          Login
        </span>
      </p>

    </div>
  );
}